export const mockVehicleIssues = [
	{
		id: 1,
		code: "IS20260616_LGK47N",
		vehicleId: 1402,
		serviceCategory: "Bodywork",
		issueType: { id: 5, name: "Rear bumper" },
		issueDescription: "Scratched by squirrels",
		createdAt: "2026-06-16T20:00:00Z",
		status: "Completed",
		allowedTransitions: [],
		workOrder: null,
		zendeskId: null,
		relatedCaseNo: null,
		handoverFlagged: true,
		handoverNote: null,
		addedBy: "jonathan.tan@getgo.sg",
		isDeleted: false,
		media: [],
	},
	{
		id: 2,
		code: "IS20260731_BXJ46C",
		vehicleId: 1401,
		serviceCategory: "Bodywork",
		issueType: { id: 1, name: "Front bumper" },
		issueDescription: "Front bumper broken due collision with pillar",
		createdAt: "2026-07-31T02:14:00Z",
		status: "InProgress",
		allowedTransitions: ["Completed", "Cancelled"],
		workOrder: { id: 4471, code: "WO20260818_L174FD" },
		zendeskId: "482910",
		relatedCaseNo: "CASE20260928_HTQKJ0",
		outcome: null,
		unfixedReason: null,
		handoverFlagged: false,
		handoverNote: null,
		addedBy: "johnsmith@getgo.sg",
		isDeleted: false,
		media: [
			{
				id: 5511,
				s3Url: "https://getgo-fms-media.s3.ap-southeast-1.amazonaws.com/mr/issues/2/bumper-01.jpg",
				mediaType: "photo",
				sortOrder: 0,
			},
		],
	},

	{
		id: 5,
		code: "IS20260731_BXJ66C",
		vehicleId: 1401,
		serviceCategory: "Maintenance",
		issueType: { id: 2, name: "Left headlight" },
		issueDescription: "Headlight bulb wiring",
		createdAt: "2026-07-31T02:20:00Z",
		status: "InProgress",
		allowedTransitions: ["Completed", "Cancelled"],
		workOrder: { id: 4471, code: "WO20260818_L174FD" },
		zendeskId: null,
		relatedCaseNo: null,
		outcome: null,
		unfixedReason: null,
		handoverFlagged: false,
		handoverNote: null,
		addedBy: "johnsmith@getgo.sg",
		isDeleted: false,
		media: [],
	},

	{
		id: 15,
		code: "IS20260731_BXJ99E",
		vehicleId: 1401,
		serviceCategory: "Maintenance",
		issueType: { id: 9, name: "Tyres" },
		issueDescription: "Worn rear tyres need replacing",
		createdAt: "2026-07-31T02:30:00Z",
		status: "InProgress",
		allowedTransitions: ["Completed", "Cancelled"],
		workOrder: { id: 4471, code: "WO20260818_L174FD" },
		zendeskId: null,
		relatedCaseNo: null,
		outcome: null,
		unfixedReason: null,
		handoverFlagged: false,
		handoverNote: null,
		addedBy: "johnsmith@getgo.sg",
		isDeleted: false,
		media: [],
	},
	{
		id: 3,
		code: "IS20260713_LXJ86H",
		vehicleId: 1402,
		serviceCategory: "Non-workshop",
		issueType: { id: 6, name: "Pest infestation" },
		issueDescription: "2 nymphs found",
		createdAt: "2026-07-13T08:00:00Z",
		status: "Assigned",
		allowedTransitions: [],
		workOrder: { id: 4473, code: "WO20260818_L17F4F" },
		zendeskId: "591204",
		relatedCaseNo: "CASE20260722_G39MB4",
		handoverFlagged: false,
		handoverNote: null,
		addedBy: "amirah.rahman@getgo.sg",
		isDeleted: false,
		media: [],
	},
	{
		id: 4,
		code: "IS20260705_PXN81C",
		vehicleId: 1402,
		serviceCategory: "Non-workshop",
		issueType: { id: 7, name: "Esso card missing" },
		issueDescription: "Esso card missing",
		createdAt: "2026-07-05T08:00:00Z",
		status: "Backlog",
		allowedTransitions: [],
		workOrder: { id: 4474, code: "WO20260818_L17F4G" },
		zendeskId: null,
		relatedCaseNo: null,
		handoverFlagged: false,
		handoverNote: null,
		addedBy: "wei.ling.koh@getgo.sg",
		isDeleted: false,
		media: [],
	},
	{
		id: 7,
		code: "IS20260728_QW91MK",
		vehicleId: 1402,
		serviceCategory: "Maintenance",
		issueType: { id: 4, name: "Aircon" },
		issueDescription: "Aircon blows warm on the passenger side",
		createdAt: "2026-07-28T09:02:00Z",
		status: "Backlog",
		allowedTransitions: ["Cancelled"],
		workOrder: null,
		zendeskId: null,
		relatedCaseNo: null,
		handoverFlagged: false,
		handoverNote: null,
		addedBy: "cx.agent@getgo.sg",
		isDeleted: false,
		media: [],
	},

	{
		id: 8,
		code: "IS20260801_NW8021",
		vehicleId: 1402,
		serviceCategory: "Non-workshop",
		issueType: { id: 8, name: "Interior cleanliness" },
		issueDescription: "Stained rear seats",
		createdAt: "2026-08-01T09:00:00Z",
		status: "Backlog",
		allowedTransitions: [],
		workOrder: null,
		zendeskId: null,
		relatedCaseNo: null,
		handoverFlagged: false,
		handoverNote: null,
		addedBy: "cx.agent@getgo.sg",
		isDeleted: false,
		media: [],
	},

	{
		id: 9,
		code: "IS20260820_NW4471",
		vehicleId: 1401,
		serviceCategory: "Non-workshop",
		issueType: { id: 7, name: "Esso card missing" },
		issueDescription: "Esso card missing",
		createdAt: "2026-08-20T03:00:00Z",
		status: "InProgress",
		allowedTransitions: ["Completed", "Cancelled"],
		workOrder: { id: 4475, code: "WO20260825_QK92LM" },
		zendeskId: null,
		relatedCaseNo: null,
		handoverFlagged: false,
		handoverNote: null,
		addedBy: "cx.agent@getgo.sg",
		isDeleted: false,
		media: [],
	},

	{
		id: 10,
		code: "IS20260810_BW9231",
		vehicleId: 1402,
		serviceCategory: "Bodywork",
		issueType: { id: 5, name: "Rear bumper" },
		issueDescription: "Rear bumper scuffed",
		createdAt: "2026-08-10T09:00:00Z",
		status: "Backlog",
		allowedTransitions: [],
		workOrder: null,
		zendeskId: null,
		relatedCaseNo: null,
		handoverFlagged: false,
		handoverNote: null,
		addedBy: "cx.agent@getgo.sg",
		isDeleted: false,
		media: [],
	},

	{
		id: 11,
		code: "IS20260718_ZZ103C",
		vehicleId: 1402,
		serviceCategory: "Bodywork",
		issueType: { id: 3, name: "Rear bumper" },
		issueDescription: "Scratch on rear bumper",
		createdAt: "2026-07-18T09:00:00Z",
		status: "InProgress",
		allowedTransitions: ["Completed", "Cancelled"],
		workOrder: { id: 4468, code: "WO20260725_A912BC" },
		zendeskId: null,
		relatedCaseNo: null,
		handoverFlagged: false,
		handoverNote: null,
		addedBy: "ops.lead@getgo.sg",
		isDeleted: false,
		media: [],
	},

	{
		id: 12,
		code: "IS20260625_QW881A",
		vehicleId: 1403,
		serviceCategory: "Maintenance",
		issueType: { id: 4, name: "Engine service" },
		issueDescription: "Scheduled engine servicing",
		createdAt: "2026-06-25T09:00:00Z",
		status: "InProgress",
		allowedTransitions: ["Completed", "Cancelled"],
		workOrder: { id: 4450, code: "WO20260701_M301XY" },
		zendeskId: null,
		relatedCaseNo: null,
		handoverFlagged: true,
		handoverNote: null,
		addedBy: "ops.lead@getgo.sg",
		isDeleted: false,
		media: [],
	},

	{
		id: 13,
		code: "IS20260826_DR120A",
		vehicleId: 1401,
		serviceCategory: "Bodywork",
		issueType: { id: 1, name: "Front bumper" },
		issueDescription: "Scratched driver door",
		createdAt: "2026-08-26T08:00:00Z",
		status: "InProgress",
		allowedTransitions: ["Completed", "Cancelled"],
		workOrder: { id: 4476, code: "WO20260827_JT44RS" },
		zendeskId: null,
		relatedCaseNo: null,
		handoverFlagged: false,
		handoverNote: null,
		addedBy: "ops.lead@getgo.sg",
		isDeleted: false,
		media: [],
	},
	{
		id: 14,
		code: "IS20260826_DR120B",
		vehicleId: 1401,
		serviceCategory: "Maintenance",
		issueType: { id: 4, name: "Aircon" },
		issueDescription: "Aircon compressor needs a part on backorder",
		createdAt: "2026-08-26T08:10:00Z",
		status: "InProgress",
		allowedTransitions: ["Completed", "Cancelled"],
		workOrder: { id: 4476, code: "WO20260827_JT44RS" },
		zendeskId: null,
		relatedCaseNo: null,
		handoverFlagged: false,
		handoverNote: null,
		addedBy: "ops.lead@getgo.sg",
		isDeleted: false,
		media: [],
	},
];
